export const UPDATE_AGENT_MONITORING_STATE = 'UPDATE_AGENT_MONITORING_STATE';
export const UPDATE_AGENT_LIVE_STATS = 'UPDATE_AGENT_LIVE_STATS';
export const AGENT_MONITORING_CUSTOMER_MESSAGE_RECEIVED = 'AGENT_MONITORING_CUSTOMER_MESSAGE_RECEIVED';
export const AGENT_MONITORING_MESSAGE_RESPONSE_RECEIVED = 'AGENT_MONITORING_MESSAGE_RESPONSE_RECEIVED';


// WEBPACK FOOTER //
// ./src/data/redux/agent_monitoring_details/actiontypes.js